export enum FormBuilderFieldType {
  Text = "text-block",
  InputDateFormField = "date-input",
  InputFormField = "text-input",
  PersonalInputTextField = "text-input-personal",
  SelectFormField = "select-input",
  SelectHierarchyFormField = "select-hierarchy-input",
  SingleCheckboxFormField = "single-checkbox-input",
  FieldGroup = "field-group",
  Captcha = "captcha",
}

export enum FormBuilderFieldInputType {
  Text = "TEXT",
  Dropdown = "DROPDOWN",
  CountryCodeDropdown = "COUNTRY_CODE_DROPDOWN",
  Checkbox = "CHECKBOX",
  SingleCheckbox = "SINGLE_CHECKBOX",
  Radio = "RADIO",
  Date = "DATE",
  None = "NONE",
}

export enum FormBuilderFieldCode {
  Email = "email",
  FirstName = "first-name",
  LastName = "last-name",
  BirthDate = "birth-date",
  NameSuffix = "name-suffix",
  Degree = "degree",
  IncomeCurrency = "income-currency",
  IncomeRange = "income-range",
  Gender = "gender",
  JobFunctions = "job-functions",
  Nationality = "nationality",
  MainLanguage = "main-language",
  SecondaryLanguage = "secondary-language",
  OrganizationBusinessType = "organization-business-type",
  OrganizationSizeInPerson = "organization-size-in-person",
  OrganizationBusinessVolume = "organization-business-volume",
  OrganizationSize = "organization-size",
  PaymentMethod = "payment-method",
  ProductSectorStandardQuestions = "productSectorStandardQuestions",
  ProductCategories = "productCategories",
  Interests = "interests",
  AgeRange = "age-range",
  JobTitle = "job-title",
  CompanyName = "company-name",
  WebAddress = "web-address",
  Facebook = "facebook",
  Instagram = "instagram",
  Linkedin = "linkedin",
  Pinterest = "pinterest",
  Skype = "skype",
  Twitter = "twitter",
  ArrivalDate = "arrival-date",
  DepartureDate = "departure-date",
  FaxCountryCode = "fax-country-code",
  FaxAreaCod = "fax-area-cod",
  FaxBaseNumber = "fax-base-number",
  Alias = "alias",
  VipCode = "vip-code",
  ProductType = "product-type",
  PurchasingBudget = "purchasing-budget",
  CountryOfResidence = "country-of-residence",
  InvisibleCaptcha = "invisible-captcha",
  GoogleCaptcha = "google-captcha",
  Address = "address",
  AddressLine1 = "address-line-1",
  AddressLine2 = "address-line-2",
  AddressLine3 = "address-line-3",
  AddressCity = "address-city",
  AddressStateOrCounty = "address-state-or-county",
  AddressCountry = "address-country",
  AddressPostcode = "address-postcode",
  AddressPoBox = "address-po-box",
  Passport = "passport",
  PassportExpiration = "passport-expiration",
  PassportIssuedDate = "passport-issued-date",
  PassportPlaceOfIssue = "passport-place-of-issue",
  PassportNumber = "passport-number",
  Phone = "phone",
  PhoneNumberCountryCode = "phone-number-country-code",
  PhoneNumberAreaCode = "phone-number-area-code",
  PhoneNumberBaseNumber = "phone-number-base-number",
  PhoneNumberExtension = "phone-number-extension",
  PhoneNumberCategory = "phone-number-category",
  StateOfResidence = "state-of-residence",
}

export enum FormBuilderConsentType {
  Relaxed = "RELAXED",
  Standard = "STANDARD",
  Casl = "CASL",
  Gdpr = "GDPR",
  Premiere = "PREMIERE",
  PremiereRelaxed = "PREMIERE_RELAXED",
  VitaFoodsGroupA = "VITA_FOODS_GROUP_A",
  VitaFoodsGroupB = "VITA_FOODS_GROUP_B",
  VitaFoodsRelaxed = "VITA_FOODS_RELAXED",
}

export enum FormBuilderConsentInputType {
  Checkbox = "CHECKBOX",
  Dropdown = "DROPDOWN",
}

export enum FormBuilderConsentOptIn {
  OptIn = "OPT_IN",
  OptOut = "OPT_OUT",
}

export enum FormBuilderConsentFieldNames {
  CombineMarketing = "combinedResponseSelected",
  ThirdParty = "marketingResponseSelected",
  Marketing = "thirdPartyResponseSelected",
}
